import type { ClientType } from 'types'

import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { CheckBigIcon } from 'icons'
import Button from 'components/Button'
import copy from 'copy.json'
import { basePaths, paths } from 'paths'

export default function FileUploadSuccessScreen({ clientType }: { clientType: ClientType }) {
  const navigate = useNavigate()
  const { buyerId, sellerId, demandId, offerId } = useParams()

  let clientId: string | undefined
  let resourceId: string | undefined

  if (clientType === 'buyer') {
    clientId = buyerId
    resourceId = demandId
  }

  if (clientType === 'seller') {
    clientId = sellerId
    resourceId = offerId
  }
  return (
    <Wrapper className="dark">
      <CheckBigIcon />

      <h1>{copy.page.file_upload_success.heading}</h1>

      <p>{copy.page.file_upload_success.paragraph}</p>

      <Button
        onClick={() =>
          navigate(`${basePaths.admin_panel}/${clientType}/${paths.search}/${clientId}`, {
            state: resourceId
          })
        }
        secondary
      >
        {copy.common.button.close}
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  width: 100%;
  max-width: 646px;
  margin: 50px auto 0;
  padding: 48px clamp(48px, 20vw, 127px);
  color: var(--white);

  background: var(--green);
  border-radius: 4px;

  h1 {
    font: var(--600-24);
  }

  p {
    font: var(--600-13);
    text-align: center;
    margin-top: -8px;
  }

  button {
    width: 100%;
    max-width: 312px;

    &:hover:enabled:not(:focus-visible) {
      background: var(--very-light-green);
    }
  }
`
